import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import { SearchEmpty } from '@src/components/common/icon';

import './global.module.less';

const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 120px 0;
`;

const TextContent = styled.div`
	margin-top: 24px;
	font-size: 16px;
	color: #101010;
`;

const ButtonContent = styled.div`
	margin-top: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	color: #FFFFFF;
	padding: 8px 16px;
	background: ${props => props.theme.colors.primary};
	border-radius: 4px;
	cursor: pointer;
`;

const Empty = ({
	resetFilter,
}: {
	resetFilter: () => void;
}): JSX.Element => {
	const { t } = useTranslation();

	const resetHandle = () => {
		resetFilter();
	};

	return (
		<Content>
			<SearchEmpty />
			<TextContent>
				{t('category:search_empty_message')}
			</TextContent>
			<ButtonContent onClick={resetHandle}>
				{t('category:search_empty_button')}
			</ButtonContent>
		</Content>
	);
};

export default Empty;
